// @ts-nocheck
import { put, takeLatest, select } from 'redux-saga/effects';
import * as slice from './reducer';
import * as sagaActions from './sagaActions';
import { getAPIDataV2, putAPIData, postAPIData, postAPIDataV3, putAPIDataV2, getAPIDataV3, putAPIDataV3 } from 'utils/api';
import qs from 'qs';
import * as dynamicGridSlice from 'models/dynamicGrid/reducer';
import _ from 'lodash';
import * as dynamicGridSagaActions from 'models/dynamicGrid/sagaActions';
import * as advertisingSagaActions from 'models/advertisings/sagaActions';
import * as advertisingSlice from 'models/advertisings/reducer';
import { AD_MODAL_TABLE_IDS, AD_TYPES_TABLE } from './constants';
import { updateAdTypeData } from '../../../organisms/adTypeModal/api';
import { triggerNotification } from 'organisms/notifications/sagaActions';
import { cleanUpGrids } from 'models/tableColumns/sagaActions';
import { getGridFilters, getTableSelection,getGridData } from 'models/dynamicGrid/selector';
import { createFiltersFromQueries } from 'models/dynamicGrid/query';
import { getPricingDataId, getAdModalData } from './selector';
import { TABLE_ID } from '../constants';
import { toggleLoader } from 'models/loaders/sagaActions';
import { REQUESTS } from 'utils/services/thetaretail/requests';
import { getWebAppSettings } from 'models/user/selector';
import { getState } from 'reducers';

function* updateModalToggle({ payload }: any) {
	const { eventName, isOpen } = payload;
	yield put(slice.updateModalToggle({ eventName, isOpen }));
	if (!isOpen) {
		yield put(dynamicGridSagaActions.cleanUpGrids([33, 31, 1]));
		yield put(cleanUpGrids([33, 31, 1]));
	}
}

function* updateAdData({ payload }: any) {
	const { eventName, data } = payload;
	yield put(slice.updateAdData({ eventName, data }));
}

function* editAdData({ payload }: any) {
	const { eventName, data } = payload;
	yield updateModalToggle({ payload: { eventName: eventName, isOpen: true } });
	const apiQuery = {
		refresh: new Date().getTime().toString()
	};

	yield put(slice.updateAdData({ eventName, data }));
	const { response, isError, error } = yield getAPIDataV3({
    service: REQUESTS.GET.GET_AD_DETAILS.service,
    url: REQUESTS.GET.GET_AD_DETAILS.url,
    pathParams: { adId: data.AdID },
  })
    .then((response) => ({ response: response?.data }))
    .catch((error) => ({ error, isError: true }));

	if (error?.message === 'CANCELLED') {
		return;
	}
	if (isError) {
		yield put(triggerNotification({ message: 'An error occurred while fetching data, please try again later.' }));
		//TODO: Do something here
		return;
	}
	let selectedStores = _.map(response?.data, item => item.StoreID);
	let selectedSkus = _.map(response?.data, item => item.SKUID);
	let selectedRowKeys = _.uniq(selectedSkus);
	let pricingData = [];
	for (let key of selectedRowKeys) {
		let index = _.findIndex(response?.data, function (e: any) {
			return e.SKUID === key;
		});
		if (index > -1) {
			pricingData.push(response?.data[index]);
		}
	}
	yield put(
		slice.updatePricingData({
			data: pricingData
		})
	);

	yield put(
		slice.updateEditMode({
			edit: true
		})
	);
	yield put(
		slice.updateEditData({
			editData: response?.data?.length ? response?.data : [data]
		})
	);
	yield put(
		dynamicGridSlice.updateSelectedRows({
			tableId: AD_MODAL_TABLE_IDS.STORES,
			data: { selectedRowKeys: _.uniq(selectedStores), isSelectAll: false }
		})
	);
	yield put(
		dynamicGridSlice.updateSelectedRows({
			tableId: AD_MODAL_TABLE_IDS.SKUS,
			data: { selectedRowKeys: _.uniq(selectedSkus), isSelectAll: false }
		})
	);
}

function* updatePricingData({ payload }: any) {
	const { data } = payload;

	yield put(
		slice.updatePricingData({
			data: data
		})
	);
}

function* handleCreateAdvertising({ payload }: any) {
	yield put(toggleLoader({ component: 'adTypesModal', isLoading: true }));

	const adModalData = yield select(getAdModalData);
	const pricingDataId = yield select(getPricingDataId);

	yield postAPIDataV3({service: REQUESTS.POST.CREATE_AD.service, url: REQUESTS.POST.CREATE_AD.url, body: { ...adModalData, AdTempID: pricingDataId, AdID: payload?.AdID }});
	yield put(sagaActions.updateModalToggle('advertising', false));

		yield put(dynamicGridSagaActions.refreshGridData({ tableId: TABLE_ID }));
}



function* cleanUp() {
	yield put(slice.cleanUp());
	yield put(
		toggleLoader({
			isLoading: false,
			component: 'adTypesModal'
		})
	);
	yield put(slice.updatePricingDataId({ pricingDataId: null }));
	yield put(dynamicGridSagaActions.cleanUpGrids({ tableIds: [50, 32, 33] }));
}

function* editAdType({ payload }: any) {
	const { eventName, data } = payload;
	yield updateModalToggle({ payload: { eventName: eventName, isOpen: true } });
	yield put(slice.updateAdTypeData({ eventName, data }));
	yield put(
		slice.updateEditMode({
			edit: true
		})
	);
}

function* updateAdType({ payload }: any) {
	const { eventName, data } = payload;
	yield put(advertisingSlice.updateLoader({ eventName: 'adTypesModal', isLoading: true }));
	const { isError, error } = yield putAPIDataV3({
    service: REQUESTS.PUT.UPDATE_AD_TYPE.service,
    url: REQUESTS.PUT.UPDATE_AD_TYPE.url,
    body: data
  }).catch(error => ({ isError: true, error }));
	yield put(advertisingSlice.updateLoader({ eventName: 'adTypesModal', isLoading: false }));
	if (error?.message === 'CANCELLED') {
		return;
	}
	if (isError) {
		yield put(triggerNotification({ message: 'An error occurred while fetching data, please try again later.' }));
		return;
	}
	yield updateModalToggle({ payload: { eventName: eventName, isOpen: false } });
	yield cleanUp();


		yield put(dynamicGridSagaActions.refreshGridData({ tableId: AD_TYPES_TABLE }));
		return;
}

function* saveAdType({ payload }: any) {
	const { title } = payload;
	const adData = {
		AdID: -1,
		AdTitle: title,
		AdType: title,
		AdTypeID: -1,
		value: title
	};
	yield put(advertisingSlice.updateLoader({ eventName: 'adTypesModal', isLoading: true }));
	const { isError, error } = yield postAPIDataV3({
    service: REQUESTS.POST.ADD_AD_TYPE.service,
    url: REQUESTS.POST.ADD_AD_TYPE.url,
    body: adData
  }).catch(e => ({ isError: true, error: e }));
	yield put(advertisingSlice.updateLoader({ eventName: 'adTypesModal', isLoading: false }));
	if (error?.message === 'CANCELLED') {
		return;
	}
	if (isError) {
		yield put(triggerNotification({ message: 'An error occurred while fetching data, please try again later.' }));
		return;
	}
	yield updateModalToggle({ payload: { eventName: 'adTypes', isOpen: false } });
	yield cleanUp();


		yield put(dynamicGridSagaActions.refreshGridData({ tableId: AD_TYPES_TABLE }));
		return;
}

function* handleUpdatePricingData({ payload }: any) {
	const { tableId, row, updatedValue, rowIdentifier, isInlineEdit } = payload;
if (tableId !== 33) {
		return;
	}
	const AdTempID = yield select(getPricingDataId);
     const adId = localStorage.getItem("adId");
     const adIdValue = (adId === null || adId === "null") ? null : Number(adId);
	try {
		yield putAPIDataV3({
			service: REQUESTS.PUT.UPDATE_PRICING_PARAMS.service, url: REQUESTS.PUT.UPDATE_PRICING_PARAMS.url, body: {
			SKUID: row.SKUID,
			[rowIdentifier]: updatedValue,
            adId: adIdValue,
			},
			pathParams: {
				AdTempID
			}
       });
	} catch (e) {}
}

function* handleSubmitPricingParams({ payload }: any) {
	try {
	  const pricingDataId = yield select(getPricingDataId);
	  const adData = yield select(getAdModalData);
	  
	  // Get AdTempID from localStorage or use pricingDataId (same logic as grid)
	  const adTempIDFromStorage = localStorage.getItem("adIdForPricing");
	  const adTempID = (adTempIDFromStorage === null || adTempIDFromStorage === "null") ? pricingDataId : adTempIDFromStorage;
	  
	  // Get grid filters to construct the proper payload
	  const tableFilters = yield select((state) =>
		getGridFilters(state, AD_MODAL_TABLE_IDS.ENTER_PRICING)
	  );
	  
	  // Construct the search object (same as getData function)
	  const search = {
		filter: createFiltersFromQueries(tableFilters?.search || [], tableFilters?.isView),
	  };
	  
	  // Build apiQuery payload (same structure as getData function creates)
	  const apiQuery = {
		...tableFilters,
		search: JSON.stringify(search),
		isAdvancedSearch: 1,
		refresh: new Date().getTime().toString(),
	  };
	  
	  // Merge with the body from dataProviderOptions (adId)
	  const requestBody = {
		...apiQuery,
		adId: adData?.AdID === "" ? null : adData?.AdID,
	  };
	  
	  // Call the same API that the grid uses to get updated pricing data
	  const response = yield postAPIDataV3({
		service: REQUESTS.POST.GET_PRICING_PARAMS.service,
		url: REQUESTS.POST.GET_PRICING_PARAMS.url,
		pathParams: { AdTempID: adTempID },
		body: requestBody,
	  });
	  
	  const enterPricingData = response?.data || [];

	  const body = {
		AdID: payload?.AdID,
		PricingParamsJSON: enterPricingData?.data,
	  };
  
	  yield putAPIDataV3({
		service: REQUESTS.PUT.UPDATE_PRICE_JSON.service, 
		url: REQUESTS.PUT.UPDATE_PRICE_JSON.url,
		body,
		pathParams: {
			AdTempID: pricingDataId
		}
	  });
	  
	  // Refresh the pricing grid data to get the updated values from the server
	  yield put(dynamicGridSagaActions.refreshGridData({ tableId: AD_MODAL_TABLE_IDS.ENTER_PRICING }));
	} catch (e) {
	  // Swallow errors for now; can add notification if needed
	}
  }

function* handleCreatePricingData({ payload }: any) {
	try {
		const { tableId, row, updatedValue, rowIdentifier, isInlineEdit } = payload;

		const storeFilters = yield select(state => getGridFilters(state, 50));
		const skuFilters = yield select(state => getGridFilters(state, 32));
		const storeIds = yield select(state => getTableSelection(state, 50));
		const skuIds = yield select(state => getTableSelection(state, 32));
		const isView = getWebAppSettings(getState())?.IsAclRowLevelAccessEnabled;

		const { data } = yield postAPIDataV3({
			service:REQUESTS.POST.CREATE_PRICING_PARAMS.service, url: REQUESTS.POST.CREATE_PRICING_PARAMS.url, body: {
				isAdvancedSearch: true,
				storeIds: storeIds?.selectedRowKeys.join(','),
				skuIds: skuIds?.selectedRowKeys.join(','),
				isSelectAllStore: storeIds.isSelectAll,
				isSelectAllSKU: skuIds.isSelectAll,
        		isView,
				selectAllSearchStore: JSON.stringify({ filter: createFiltersFromQueries(storeFilters.search) }),
				selectAllSearchSku: JSON.stringify({ filter: createFiltersFromQueries(skuFilters.search) })
			}
		});
		yield put(
			slice.updatePricingDataId({
				pricingDataId: data.AdTempID
			})
		);
	} catch (e) {
		console.log(e);
	}
}

export default function* rootSaga() {
	return [
		yield takeLatest(sagaActions.updateModalToggle, updateModalToggle),
		yield takeLatest(sagaActions.updateAdData, updateAdData),
		yield takeLatest(sagaActions.editAdData, editAdData),
		yield takeLatest(sagaActions.updatePricingData, updatePricingData),
		yield takeLatest(sagaActions.cleanUp, cleanUp),
		yield takeLatest(sagaActions.editAdType, editAdType),
		yield takeLatest(sagaActions.updateAdType, updateAdType),
		yield takeLatest(sagaActions.saveAdType, saveAdType),
		yield takeLatest(sagaActions.createPricingData, handleCreatePricingData),
		yield takeLatest(dynamicGridSagaActions.updateRowData, handleUpdatePricingData),
		yield takeLatest(sagaActions.createNewAdvertising, handleCreateAdvertising),
		yield takeLatest(sagaActions.submitPricingParams, handleSubmitPricingParams)
	];
}

